export const listSx = {
    display: 'flex',
    flexDirection: 'column',
    gap: 2.25,
    width: '100%'
};

export const sectionLabelSx = {
    fontSize: 12,
    fontWeight: 800,
    color: 'text.secondary',
    textTransform: 'uppercase',
    letterSpacing: '.4px',
    mb: 1.125
};

// Looks like the select fields below it; a tap opens the date range picker.
export const dateFieldSx = (hasValue, disabled) => (theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    width: '100%',
    minHeight: theme.sizes.buttonHeightLarge,
    px: 1.75,
    py: 1.25,
    font: 'inherit',
    fontSize: 14,
    textAlign: 'left',
    color: hasValue ? theme.palette.text.primary : theme.palette.text.placeholder,
    bgcolor: 'transparent',
    border: 1,
    borderColor: theme.palette.border.input,
    borderRadius: `${theme.shape.borderRadius}px`,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1
});

export const dateHelperSx = (isError) => ({
    fontSize: 12,
    mt: 0.75,
    color: isError ? 'error.main' : 'text.secondary'
});

// The filter fields are sized for a row of the desktop toolbar; in the sheet
// each takes the full width.
export const fieldSx = {
    'width': '100%',
    '& .MuiFormControl-root, & .MuiAutocomplete-root, & .MuiTextField-root': {
        width: '100%',
        maxWidth: '100%'
    }
};
